
export class HeaderSitecoreTemplate {
  public LoginGreetingLabel: string;
  public ProgramHeaderLabel: string;
  public HealthNetworkHeaderLabel: string;
  public EligibilityHeaderLabel: string;
  public PcpHeaderLabel: string;
}
